module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[74]439.d388792.woff2";